import React, { useState } from 'react';
import { 
  AppBar, 
  Toolbar, 
  IconButton, 
  Menu, 
  MenuItem, 
  useMediaQuery, 
  Button, 
  Box
} from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import styles from './Header.module.css';
import { featureFlags } from '../../../featureFlags';

const Header: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box className={styles.headerContainer}>
      <AppBar position="static">
        <Toolbar className={styles.toolbar}>
          <Link to="/" className={styles.logoLink}>
            <img 
              src={"/morgan.png"} 
              alt="Home" 
              className={styles.logo}
            />
          </Link>
          
          <Box className={styles.spacer} />
          
          {!isMobile ? (
            <>
              {featureFlags.showCareerPage && (
                <Button 
                  component={Link}
                  to="/career"
                  variant="contained"
                  className={styles.button1}
                >
                  Career
                </Button>
              )}
              
              {featureFlags.showAboutPage && (
                <Button 
                  component={Link}
                  to="/about"
                  variant="contained"
                  className={styles.button2}
                >
                  About
                </Button>
              )}
            </>
          ) : (
            (featureFlags.showCareerPage || featureFlags.showAboutPage) && (
              <IconButton color="inherit" onClick={handleMenuOpen}>
                <FontAwesomeIcon icon={faBars} className={styles.menuIcon} />
              </IconButton>
            )
          )}

          {/* TODO: implement filtering below */}
          {/* {!isMobile ? (
            <Box className={styles.searchContainer}>
              <TextField
                placeholder="Search posts..."
                value={searchValue}
                onChange={handleSearchChange}
                size="small"
                className={styles.searchField}
              />
              
              <Autocomplete
                multiple
                options={availableTags}
                value={selectedTags}
                onChange={handleTagChange}
                size="small"
                className={styles.autocomplete}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Filter by tags"
                  />
                )}
                renderTags={(value, getTagProps) =>
                  value.map((option, index) => (
                    <Chip
                      label={option}
                      {...getTagProps({ index })}
                      size="small"
                      className={styles.chip}
                    />
                  ))
                }
              />
            </Box>
          ) : (
            <IconButton color="inherit" onClick={handleMenuOpen}>
              <MenuIcon className={styles.menuIcon} />
            </IconButton>
          )} */}
          
          <Menu 
            anchorEl={anchorEl} 
            open={Boolean(anchorEl)} 
            onClose={handleMenuClose}
            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            PaperProps={{
              className: styles.menu
            }}
          >
            {featureFlags.showCareerPage && (
              <MenuItem onClick={handleMenuClose} component={Link} to="/career">Career</MenuItem>
            )}
            {featureFlags.showAboutPage && (
              <MenuItem onClick={handleMenuClose} component={Link} to="/about">About</MenuItem>
            )}
          </Menu>
        </Toolbar>
      </AppBar>
    </Box>
  );
};

export default Header;